import { roundToPlaces } from "../../utils/roundToPlaces.js";
import { DeliveryType, paidDeliveryTypes } from "../DeliveryType.js";
import type { Order, OrderCreateInput } from "../Order.js";
import { TaxLevel } from "../TaxLevel.js";
import { deliveryCommonPrice } from "../deliveryCommonPrice.js";
import { deliveryFreeThreshold } from "../deliveryFreeThreshold.js";
import { calculatePriceWithoutTax } from "./calculatePriceWithoutTax.js";
import { getPriceOfOrderProduct } from "./getPriceOfOrderProduct.js";

export function getPriceOfOrder({
	products,
	deliveryType = DeliveryType.Personal,
}: Pick<OrderCreateInput, "products"> & Pick<Partial<OrderCreateInput>, "deliveryType">): Order["prices"] {
	let withTax = 0;
	let withoutTax = 0;

	for (const product of products) {
		const { withTax: productWithTax, withoutTax: productWithoutTax } = getPriceOfOrderProduct(product);
		withTax += productWithTax;
		withoutTax += productWithoutTax;
	}

	const deliveryPrice =
		withTax < deliveryFreeThreshold && paidDeliveryTypes.includes(deliveryType) ? deliveryCommonPrice : 0;
	const deliveryPriceWithoutTax = deliveryPrice && calculatePriceWithoutTax(deliveryPrice, TaxLevel.TaxLevel21);

	return {
		deliveryPrice,
		deliveryPriceWithoutTax,
		totalPrice: {
			withoutTax: roundToPlaces(withoutTax, 2) + deliveryPriceWithoutTax,
			withTax: roundToPlaces(withTax, 2) + deliveryPrice,
		},
	};
}
